module.exports = __webpack_public_path__ + "static/media/case-study-1.e64be67c.pdf";